import { paymentClient } from "@core/clients";
import { TinkoffPayment, TOrder } from "@core/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

type UseGetTinkoffPaymentQueryProps = {
  orderId: TOrder["id"];
  options?: UseQueryOptions<TinkoffPayment | null, any, TinkoffPayment | null, any>;
};

const useGetTinkoffPaymentQuery = ({ orderId, options }: UseGetTinkoffPaymentQueryProps) => {
  return useQuery({
    queryKey: ["t-payment", orderId],
    queryFn: () => paymentClient.getTinkoffPayment(orderId),
    ...options,
  });
};

export default useGetTinkoffPaymentQuery;
